import type { components } from "@/api/schema";
import type { IntentName } from "@/design";

export type NotificationDelivery = components["schemas"]["NotificationDelivery"];
export type DeliveryStatus = NotificationDelivery["status"];

export const DELIVERY_STATUS_INTENT: Record<DeliveryStatus, IntentName> = {
  sent: "success",
  failed: "danger",
  retrying: "warning",
};

export interface DeliveryFilter {
  status?: DeliveryStatus;
  channel?: string;
  offset?: number;
  limit?: number;
}
